import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { colors, typography } from '../../../styles';
import ContactModal from '../../ContactModal';

const styles = css`
  .ContactBanner {
    padding: 45px 0;
    position: relative;
    overflow: hidden;
    @media (min-width: 992px) {
      padding: 120px 0;
      &::after {
        content: '';
        position: absolute;
        z-index: -1;
        width: 100vw;
        height: 500px;
        right: 0;
        top: -420px;
        background-color: ${colors.black};
        transform: skewY(-11deg);
        opacity: .05;
      }
    }
  }
  .ContactBanner_heading {
    font-size: 30px;
    line-height: 1;
    font-family: ${typography.Serif};
    color: ${colors.brand2};
    position: relative;
    text-align: center;
    @media (min-width: 480px) {
      font-size: 36px;
    }
    @media (min-width: 992px) {
      font-size: 42px;
    }
    @media (min-width: 1201px) {
      font-size: 68px;
      text-align: left;
    }
    &::after {
      content: '';
      display: block;
      margin: 15px auto;
      width: 75px;
      height: 4px;
      background-color: ${colors.brand4};
      @media (min-width: 480px) {
        margin: 30px auto;
      }
      @media (min-width: 1201px) {
        margin: 30px 0;
      }
    }
  }
  .ContactBanner_inner {
    background-color: ${colors.brand1};
    background-image: url('/images/pattern-01-dark.svg');
    background-position: center center;
    background-size: cover;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content:center;
    @media (min-width: 1201px) {
      flex-direction: row-reverse;
    }
  }
  .ContactBanner_content{
    padding: 30px;
    text-align: center;
    @media (min-width: 992px) {
      padding: 0 30px 45px 30px;
    }
    @media (min-width: 1201px) {
      padding: 45px;
      text-align: left;
    }
    @media (min-width: 1700px) {
      padding: 60px;
    }
  }
  .ContactBanner_title {
    font-size: 30px;
    line-height: 1;
    font-weight: 400;
    font-family: ${typography.Serif};
    margin: 0 0 10px 0;
    color: ${colors.white};
    text-align: center;
    @media (min-width: 480px) {
      font-size: 36px;
    }
    @media (min-width: 992px) {
      font-size: 48px;
    }
    @media (min-width: 1201px) {
      text-align: left;
    }
  }
  .ContactBanner_subtitle {
    font-size: 24px;
    font-weight: 700;
    color: ${colors.brand2};
    text-transform: uppercase;
    font-family: ${typography.Condensed};
    letter-spacing: 2px;
    text-align: center;
    @media (min-width: 480px) {
      font-size: 30px;
    }
    @media (min-width: 1201px) {
      text-align: left;
    }
  }
  .ContactBanner_contactWrapper {
    margin: 30px 0 0 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media (min-width: 1201px) {
      justify-content: flex-start;
      flex-flow: row wrap;
    }
  }
  .ContactBanner_button {
    margin: 5px 10px;
  }
  .ContactBanner_media {
    padding: 30px;
    @media (min-width: 992px) {
      padding: 45px;
    }
    @media (min-width: 1700px) {
      padding: 90px;
    }
  }
  .ContactBanner_mediaInner {
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background-size: cover;
    background-position: center center;
    @media (min-width: 1700px) {
      width: 280px;
      height: 280px;
    }
  }
  .btn {
    white-space:nowrap;

    a {
    color:white !important;
  }
  }
`;

function ContactBanner({ content, agent }) {
  return (
    <div className={styles}>
      <div className="ContactBanner">
        <div className="container">
          <div className="row">
            <div className="col-xl-3">
              <h3 className="ContactBanner_heading">{get(content, '[0].heading')}</h3>
            </div>
            <div className="col-xl-9">
              <div className="ContactBanner_inner">
                <div className="ContactBanner_media">
                  <div className="ContactBanner_mediaInner" style={{ backgroundImage: `url(${buildThumbnailUrl(get(agent, 'logo.contentUrl'), { width: 800, height: 800, exact: true })})` }} />
                </div>
                <div className="ContactBanner_content">
                  <h3>
                    <div className="ContactBanner_supertitle" />
                    <div className="ContactBanner_title">{get(content, '[0].title')}</div>
                    <div className="ContactBanner_subtitle">{get(content, '[0].subtitle')}</div>
                  </h3>
                  <p className="ContactBanner_description" />
                  <div className="ContactBanner_contactWrapper">
                    <div className="ContactBanner_button">
                      <div className="btn btn-hollow-white btn-phone-white">
                        <a href={`tel:${get(agent, 'telephone').replace(/[^0-9]/g, '')}`}>Call {get(agent, 'telephone').replace(/\((\d{3})\)\s(\d{3})\s-\s(\d{4})/g, '($1) $2-$3')}</a>
                      </div>
                    </div>
                    <div className="ContactBanner_button">
                      <ContactModal>
                        <span className="btn btn-chat-white">{get(content, '[0].button_text')}</span>
                      </ContactModal>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ContactBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  agent: PropTypes.object,
};

ContactBanner.defaultProps = {
  agent: undefined,
  widget: undefined,
};

export default withData(
  {
    agent: true,
    widget: 'contact_banner',
  },
)(ContactBanner);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/ContactBanner.section.js